import React, { useEffect, useState, useRef } from "react";
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import { Link , useNavigate, useLocation ,useParams } from "react-router-dom";
import { BsCheckLg, BsFiles } from "react-icons/bs";
import {alert} from "../components/MegConfirmAlert";
import Product2 from "../components/Product2";
import { useSearchParams } from "react-router-dom";
import { useAxios } from "../services/useAxios";
import { useTranslation } from 'react-i18next';

export default function OrderFin(props) {
    const { t } = useTranslation();

    const navigate = useNavigate();
    const AlertOrder = async (text) => {
        await navigator.clipboard.writeText(text);
        alert('주문번호가 복사되었습니다', {okText:t(`Message.common_ok`)}); 
    }
    const userInfo = JSON.parse(localStorage.getItem("user")).data;
    const [searchParams] = useSearchParams();
    const resultCode = searchParams.get('resultCode');
    const id = searchParams.get('id')    
    const [data, setData] = useState({});
    const [request] = useAxios();

    const fetchData = async () => {        
        if(resultCode === '0000'){
            const response = await request.post("/app/order/orderPaymentResultAPI",{
                orderNo : id,
                userId : userInfo.userId
            });            
            if(response.data.resultCode === 200){
                console.log(response.data.result)
                setData(response.data.result);
            }
        }else{
            const response = await request.post("/app/order/getNiceErrorMessageAPI",{
                code : resultCode
            });
            alert(response.data.resultMessage);
            navigate('/');
        }
    };
    useEffect(() => {
        fetchData();
      }, []);
    return (
        <div>
        {resultCode === '0000' && data.orderSheetVO?(       
        <div className="orderFin">
            <div className="finMent">
                <div className="checkBig">
                    <BsCheckLg />
                </div>
                {data.vaInfo?(
                    <>
                    <p className="cNavy">{t(`Message.order_payment_va_result_screen_order_wait_sttus_msg`) + ' ' + t(`Message.order_payment_va_result_screen_order_succ_msg`)}</p>
                    <p className="orderNum">{t(`Message.order_payment_va_result_screen_diposit_acunt_num`)} <span className="cOrg">({data.vaInfo.bank_nm}){data.vaInfo.va_no}</span></p>
                    <button type="button" className="btn2424" onClick={(e)=>AlertOrder(data.vaInfo.va_no)}><BsFiles /></button>
                    </>
                ):(
                    <>
                    <p className="cNavy">{t(`Message.order_payment_result_screen_pay_succ_msg`)}</p>
                    <p className="orderNum">{t(`Message.order_payment_result_screen_order_no`)} <span className="cOrg">{data.orderSheetVO.orderNo}</span></p>
                    <button type="button" className="btn2424" onClick={(e)=>AlertOrder(data.orderSheetVO.orderNo)}><BsFiles /></button>
                    </>
                )}
            </div>
            <div className="orderInfo">
                <Tabs
                    id="controlled-tab-example"
                    defaultActiveKey={data.vaInfo?"tab2":"tab1"}
                    className="tabType1"
                    >
                    {data.vaInfo?(
                    <Tab eventKey="tab2" title={t(`Message.my_order_detail_payment_info_pay_info`)}>
                        <div className="modalTabWr">
                            <ul className="ltrc">
                                <li>
                                    <p className="lt">{t(`Message.order_payment_va_result_screen_order_no`)}</p>
                                    <div className="rc">
                                        <p>{data.vaInfo.ordr_no}</p>
                                    </div>
                                </li>
                                <li>
                                    <p className="lt">{t(`Message.order_payment_va_result_screen_pay_method`)}</p>
                                    <div className="rc">
                                        <p>{t(`Message.order_payment_result_screen_virtual_account`)}</p>
                                    </div>
                                </li>
                                <li>
                                    <p className="lt">{t(`Message.order_payment_result_screen_diposit_acunt_num`)}</p>
                                    <div className="rc">
                                        <p>({data.vaInfo.bank_nm}){data.vaInfo.va_no}</p>
                                    </div>
                                </li>
                                <li>
                                    <p className="lt">{t(`Message.order_payment_va_result_screen_acunt_holder`)}</p>
                                    <div className="rc">
                                        <p>주식회사 살리코리아(SALEE KOREA)</p>
                                    </div>
                                </li>
                                <li>
                                    <p className="lt">{t(`Message.order_payment_va_result_screen_diposit_amt`)}</p>
                                    <div className="rc">
                                        <p>￦{data.orderSheetVO.lastSetleAmount.toLocaleString('ko-KR')}</p>
                                    </div>
                                </li>
                                <li>
                                    <p className="lt">{t(`Message.order_payment_va_result_screen_diposit_exp_dt`)}</p>
                                    <div className="rc">
                                        <p>{data.vaInfo.expr_tlml}</p>
                                    </div>
                                </li>
                            </ul>  
                        </div>
                    </Tab>
                    ):null}
                    <Tab eventKey="tab1" title={t(`Message.goods_dlvy_dc_info_dlvy_info`)}>
                        <div className="modalTabWr">
                            <ul className="ltrc">
                                <li>
                                    <p className="lt">{t(`Message.order_payment_result_screen_recipient`)}</p>
                                    <div className="rc">
                                        <p>{data.orderSheetVO.recptrNm}</p>
                                    </div>
                                </li>
                                <li>
                                    <p className="lt">{t(`Message.order_payment_result_screen_contact`)}</p>
                                    <div className="rc">
                                        <p>{data.orderSheetVO.recptrCttpc}</p>
                                    </div>
                                </li>
                                <li>
                                    <p className="lt">{t(`Message.order_payment_result_screen_adres`)}</p>
                                    <div className="rc">
                                        <p>{data.orderSheetVO.recptrBassAdres} {data.orderSheetVO.recptrDetailAdres}</p>
                                    </div>
                                </li>
                                <li>
                                    <p className="lt">{t(`Message.order_payment_result_screen_ent_pwd`)}</p>
                                    <div className="rc">
                                        <p>{data.orderSheetVO.entrncPass}</p>
                                    </div>
                                </li>
                                <li>
                                    <p className="lt">{t(`Message.order_payment_result_screen_dlvy_memo`)}</p>
                                    <div className="rc">
                                        <p>{data.orderSheetVO.dlvyMemo}</p>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </Tab>
                    {data.paymentInfo?(
                    <Tab eventKey="tab2" title={t(`Message.my_order_detail_payment_info_pay_info`)}>
                        <div className="modalTabWr">
                            
                            <ul className="ltrc">
                                <li>
                                    <p className="lt">{t(`Message.order_payment_result_screen_pay_method`)}</p>
                                    <div className="rc">
                                        <p>{data.paymentInfo.payMethod==='card'? t(`Message.order_payment_result_screen_credit_card`)
                                        :data.paymentInfo.payMethod==='naverpay'?'네이버페이'
                                        :data.paymentInfo.payMethod==='kakaopay'?'카카오페이'
                                        :data.paymentInfo.payMethod==='bank'?'실시간계좌이체'
                                        :data.paymentInfo.payMethod==='samsungpay'?'삼성페이':''}</p>
                                    </div>
                                </li>
                                {data.cardInfo?(
                                <>

                                {data.paymentInfo.payMethod==='bank'?(
                                <li>
                                    <p className="lt">{t(`Message.payment_method_select_account_transfer`)}</p>
                                    <div className="rc">
                                        <p>{data.cardInfo.bankName}</p>
                                    </div>
                                </li>

                                ):(
                                    <>
                                <li>
                                    <p className="lt">{t(`Message.order_payment_result_screen_pay_card_info`)}</p>
                                    <div className="rc">
                                        <p>{data.cardInfo.cardName} {data.cardInfo.cardNum}</p>
                                    </div>
                                </li>
                                <li>
                                    <p className="lt">{t(`Message.order_payment_result_screen_installment`)}</p>
                                    <div className="rc">
                                        <p>{data.cardInfo.cardQuota === 0 ? t(`Message.my_order_detail_payment_info_pay_card_quota1`) : t(`Message.my_order_detail_payment_info_pay_card_quota2` , { cardQuota : data.cardInfo.cardQuota}) }</p>
                                    </div>
                                </li>
                                </>
                                )}
                                
                                </>
                                ):null}
                                <li>
                                    <p className="lt">{t(`Message.order_payment_result_screen_approv_amt`)}</p>
                                    <div className="rc">
                                        <p>￦{Number(data.paymentInfo.amount).toLocaleString('ko-KR')}</p>
                                    </div>
                                </li>
                                <li>
                                    <p className="lt">{t(`Message.order_payment_result_screen_approv_dt`)}</p>
                                    <div className="rc">
                                        <p>{data.paymentInfo.paidAt}</p>
                                    </div>
                                </li>
                            </ul>                           
                        </div>
                    </Tab>
                    ):null}
                    <Tab eventKey="tab3" title={t(`Message.order_payment_result_screen_order_goods_info`)}>
                        <div className="modalTabWr">
                            <div className="prodWr bde mb10">
                            {data.goodsOptnInfoList && data.goodsOptnInfoList.map((obj, index) => (     
                                <Product2 key={index} type="type6" 
                                img={"https://www.salee.co.kr/com/cmm/getGoodsImageView.sale?goodsFileTy=i&goodsFileSn="+obj.goodsImageSn}
                                prodName={obj.goodsNm}
                                            option={obj.firstOptnNm + ' ' +obj.firstOptnValue}                                       
                                            disprice={"￦"+obj.sleAmount.toLocaleString('ko-KR')}
                                            cost={"￦"+obj.nrmltAmount.toLocaleString('ko-KR')}/>
                            ))}                                      
                            </div>
                            <ul className="ltrc">
                                <li>
                                    <p className="lt">{t(`Message.order_payment_result_screen_tot_amt`)}</p>
                                    <div className="rc">
                                        <p>￦{data.totGoodsAmount.toLocaleString('ko-KR')}</p>
                                    </div>
                                </li>
                                <li>
                                    <p className="lt">{t(`Message.order_payment_result_screen_dlvy_amt`)}</p>
                                    <div className="rc">
                                        <p>(+) ￦{data.orderSheetVO.dlvyCtAmount.toLocaleString('ko-KR')}</p>
                                    </div>
                                </li>
                                <li>
                                    <p className="lt">{t(`Message.order_payment_result_screen_cpn_sle_amt`)}</p>
                                    <div className="rc">
                                        <p>(-) ￦{data.orderSheetVO.couponDscntAmount.toLocaleString('ko-KR')}</p>
                                    </div>
                                </li>
                                <li>
                                    <p className="lt">{t(`Message.order_payment_result_screen_mlg_use_amt`)}</p>
                                    <div className="rc">
                                        <p>(-) ￦{data.orderSheetVO.mlgUseAmount.toLocaleString('ko-KR')}</p>
                                    </div>
                                </li>
                                <li>
                                    <p className="lt">{t(`Message.order_payment_result_screen_pay_amt`)}</p>
                                    <div className="rc">
                                        <p className="cOrg fs16 fw700">￦{data.orderSheetVO.lastSetleAmount.toLocaleString('ko-KR')}</p>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </Tab>
                </Tabs> 
            </div>
            <div className="btnWr">
                <Link to="/OrderHistory" className="btn44 navyB cFFF">{t(`Message.order_payment_result_screen_order_hist_view`)}</Link>
                <Link to="/" className="btn44 orgB cFFF">{t(`Message.order_payment_result_screen_countinue_shopping`)}</Link>
            </div>
        </div>
       
        ):null}
         </div>
    );
};